import I18n from 'i18n-js'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import Button from '../../shared/Button'

const Wrapper = styled.div`
  text-align: center;
`

const ShowMoreButton = ({ onClick, loading, numberShown, total }) => {
  const [shown, show] = useState(false)
  useEffect(() => {
    show(total > numberShown)
  }, [numberShown, total])
  return (
    <Wrapper>
      {shown ? (
        <Button
          buttonStyle={'text'}
          loading={loading}
          onClick={onClick}
          trackingData={{ currentlyShown: numberShown, totalResults: total }}
          trackingEvent={'Show More Clicked'}
        >
          {I18n.t('shared.showMore')}
        </Button>
      ) : null}
    </Wrapper>
  )
}

ShowMoreButton.defaultProps = {
  loading: false,
}

export default ShowMoreButton
